import { faShoppingCart } from "@fortawesome/pro-solid-svg-icons";
import {
  FontAwesomeIcon,
  type FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

const CartIcon = ({ ...props }: Omit<FontAwesomeIconProps, "icon">) => (
  <FontAwesomeIcon icon={faShoppingCart} {...props} />
);

export { CartIcon };
